export const routes = {
  chatrooms: {
    create: '/chatrooms',
    delete: (chatroom: string) => `/chatrooms/${chatroom}`,
    edit: (chatroom: string) => `/chatrooms/${chatroom}`,
    find: '/chatrooms',
    get: (chatroom: string) => `/chatrooms/${chatroom}`,
    members: {
      add: (chatroom: string) => `/chatrooms/${chatroom}/members`,
      remove: (chatroom: string, member: string) => `/chatrooms/${chatroom}/members/${member}`,
    },
    messages: {
      create: (chatroom: string) => `/chatrooms/${chatroom}/messages`,
      get: (chatroom: string) => `/chatrooms/${chatroom}/messages`,
    },
    stats: '/chatrooms/stats',
    status: (chatroom: string) => `/chatrooms/${chatroom}/status`,
  },
  media: {
    alt: (media: string, alt: string) => `/media/resource/${media}/${alt}`,
    create: '/media',
    delete: (media: string) => `/media/${media}`,
    get: (media: string) => `/media/${media}`,
    getAvatarFile: (user: string, type: string, alt: string) => `/media/resource/${alt}/${type}/${user}`,
    getFile: (media: string) => `/media/resource/${media}`,
  },
  pageMeta: {
    get: (url: string) => `/page-meta?url=${url}`,
  },
  users: {
    find: '/users',
  },
} as const;
